const iconNameExp = /^(\S+)\.([a-z-]+)$/

export default {
  name: 'KIcon',
  props: {
    // 使用的图标 @deprecated 使用 name
    icon: {
      type: String,
      default: '',
    },
    // 使用的图标 代替 icon
    name: {
      type: String,
      default: '',
    },
    fixedWidth: {
      type: Boolean,
      default: false,
    },
    rotation: {
      type: Number,
      default: 0,
    },
    circle: {
      type: Boolean,
      default: false,
    },
  },
  render(createElement) {
    const matches = (this.name || this.icon).match(iconNameExp) || []
    const prefix = matches[1] || 'sati'
    const name = matches[2] || this.name || this.icon
    const iconAttrs = {
      staticClass: prefix,
      class: {
        [`${prefix}-${name}`]: true,
        [`icon-fw`]: this.fixedWidth,
      },
      attrs: {
        ...this.attrs,
      },
      on: {
        ...this.$listeners,
      },
    }

    if (this.circle) {
      return createElement(
        'span',
        {
          staticClass: 'km-icon km-icon--circle',
        },
        [createElement('i', iconAttrs, this.$slots.default)],
      )
    } else {
      iconAttrs.staticClass = `km-icon ${prefix}`
      return createElement('i', iconAttrs, this.$slots.default)
    }
  },
}
